import { Shield, Check } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface VerificationBadgeProps {
  isVerified?: boolean;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

export const VerificationBadge = ({ 
  isVerified = false, 
  size = 'md',
  showText = false 
}: VerificationBadgeProps) => {
  if (!isVerified) {
    return null;
  }

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4', 
    lg: 'h-5 w-5'
  };

  const iconSize = iconSizes[size];

  const badgeContent = (
    <Badge 
      variant="secondary" 
      className="bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-200 flex items-center gap-1"
    >
      <Shield className={`${iconSize} text-blue-600`} />
      {showText && <span className="text-xs font-medium">Verified</span>}
    </Badge>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {badgeContent}
      </TooltipTrigger>
      <TooltipContent>
        <div className="flex items-center gap-1">
          <Check className="h-3 w-3 text-green-600" />
          <span className="text-xs">Verified Account</span>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};